export const vns = {
    listagem: {
        titulo_pagina: 'Lista VNS\'s',
        novo: 'Crear Nuevo VNS',
        table: {
            empty: "No se encontró VNS",
            habilitado: 'Capaz',
            desabilitado: 'Desactivado',
            nome: 'Nombre',
            empresa: 'Empresa',
            integracao_origem: 'Integración de Origen',
            integracao_destino: 'Integración de Destino',
            modem: {
                label: 'Módem',
                serial: 'De serie',
                empresa: 'Empresa',
                chip: 'Chip',
                limit: 'Límite',
                alerta: 'Alerta',
                consumo: 'Consumo',
            },
            numero_gps: 'Número',
            sensor_temperatura: 'Sensor de Temperatura',
            estado: 'Estado',
            monitor: 'Monitor',
            acoes: 'Acciónes',
            editar: 'Editar'
        }
    },
    permissoes: {
        index: {
            nome: 'Nombre',
            acoes: 'Comportamiento'
        },
        form: {
            titulo_pagina: 'Editar Permisos',
            botao_salvar: 'Guardar Permisos',
            update: {
                success: "¡Permisos Actualizados con Éxito!",
                error: "¡Error al Actualizar los Permisos!"
            }
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo VNS',
            editar: 'Editar VNS'
        },
        create:{
            success: 'VNS Creado con Éxito',
            error: '¡Error al crear VNS!'
        },
        update:{
            success: 'VNS actualizado con éxito',
            error: 'Error al actualizar VNS'
        },
        fieldsets: {
            informacoes: 'Información',
            integracoes: 'Integraciones',
            perifericos: 'Periféricos'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre VNS'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa a la que pertenece el VNS'
            },
            unidade: {
                label: 'Unidad',
                description: 'Unidad de servicio de la empresa'
            },
            setor: {
                label: 'Sector',
                description: 'Sector de unidades de servicio'
            },
            estado: {
                label: 'Estado',
                description: 'Estado em que se encontra o VNS'
            },
            integracao_origem: {
                label: 'Integración de Origen',
                description: '¿Cuál es el origen de la integración?'
            },
            credencial_origem: {
                label: 'Credencial de Origen',
                description: 'Credencial de Origen de Integración'
            },
            integracao_destino: {
                label: 'Integración de Destino',
                description: '¿Cuál es el propósito de la integración?'
            },
            credencial_destino: {
                label: 'Credencial de Destino',
                description: 'Credencial de Destino de Integración'
            },
            integracao_impressao: {
                label: 'Integración de Impresión',
                description: '¿Qué es la integración de impresión?'
            },
            credencial_impressao: {
                label: 'Imprimir Credencial',
                description: 'Imprimir Credencial'
            },
            atributos: {
                label: 'Atributos',
                description: 'Atributos Utilizados para la Integración'
            },
            modem: {
                label: 'Módem',
                description: 'Estado del módem VNS (activo o inactivo)',
                dados: 'Información del Módem',
                serial: {
                    label: 'De serie',
                    description: 'Serie del módem VNS'
                },
                numero_chip: {
                    label: 'Número',
                    description: 'Número de chip de módem'
                },
                empresa: {
                    label: 'Empresa',
                    description: 'Empresa de Módem'
                },
                data_limit: {
                    label: 'Límite de Datos',
                    description: 'Límite de datos del módem'
                },
                data_alert: {
                    label: 'Alerta de Datos',
                    description: 'Número de datos de alerta de módem'
                },
                data_consumption: {
                    label: 'Consumo',
                    description: 'Consumo de Módem'
                }
            },
            gps: {
                label: 'GPS',
                description: 'Estado del VNS GPS (activo o inactivo)',
                numero: {
                    label: 'Número',
                    description: 'Número de GPS'
                }
            },
            sensor_temperatura: {
                label: 'Temperatura',
                description: 'Estado del sensor de temperatura VNS (activo o inactivo)'
            },
            status: {
                label: 'Estado',
                description: 'Estado de VNS (activo o inactivo)'
            },
            monitor: {
                label: 'Monitor',
                description: 'Mostrar en VNS Monitor (activo o inactivo)'
            },
            botao_salvar: 'Guardar VNS'
        }
    },
    ranges: {
        listagem: {
            novo: 'Crear Nuevo Rango',
            table: {
                empty: "No se encontró rango",
                editar: "Editar",
                valor_inicial: 'Valor Inicial',
                valor_final: 'Valor Final',
                fundo: "Color de Fondo",
                letra: "Color de Fuente"
            }
        },
        form: {
            titulo_pagina: {
                criar: 'Crear Nuevo Rango',
                editar: 'Editar Rango'
            },
            fields: {
                inicio: 'Comienzo del Rango',
                final: 'Fin de Rango',
                fundo: {
                    label: 'Gama de colores',
                    description: 'Rango de color de fondo'
                },
                escrita: {
                    label: 'Color de Escritura',
                    description: 'Color de Letra de Rango'
                },
                botao_salvar : 'Guardar Rango'
            },
            create: {
                success: "¡Rango creado con éxito!",
                error: "¡Error al crear el rango!"
            },
            update: {
                success: "¡Rango editado con éxito!",
                error: "¡Error al editar el rango!"
            }
        }
    },
}

export const monitoramento = {
    titulo_automacao: 'Automatización VNS',
    titulo_display: 'VNS Display',
    titulo_quick: 'VNS Quick',
    titulo_link: 'VNS Link',
    titulo_all: 'Listado VNS',
    tipos_integracao: {
        impressora: 'Impresora',          
        automacao: 'Automatización',          
        lis: 'LIS',          
        display: 'Display',         
        generic: 'Generic',          
        quick: 'Quick',          
        his: 'HIS',          
        label: 'Label',          
        temp: 'Temperatura',
        indefinido: 'Indefinido'
    },
    resumo: {
        tabs: {
            informacoes: {
                title: 'Información',
                list: {
                    tipo: 'Tipo',
                    integracao: 'Integración',
                    impressora: 'Impresora',
                    sensor: 'Sensor de Temperatura',
                    enviados: 'Datos Enviados',
                    recebidos: 'Datos Recibidos'
                }
            },
            comandos: {
                title: 'Comandos',
                versoes: {
                    title: 'Versión actualizada',
                    informe_versao: 'O decir la versión',
                    update_button: 'Actualizar',
                    sucesso: '¡Comando enviado con éxito!',
                    error: '¡Error al enviar el comando, verifique el LOG!'
                },
                atividade: {
                    title: 'Activar actividad VNS',
                    informe_comando: 'Ingrese el comando',
                    send_button: 'Enviar Comando',
                    sucesso: '¡Comando enviado con éxito!',
                    error: '¡Error al enviar el comando, verifique el LOG!',
                    comando_para_vns: 'Comando para VNS'
                }
            },
            latencia: {
                title: 'Latencia',
                tabs: {
                    ultimo: 'Último',
                    historico: 'Histórico',
                },
                little_cards: {
                    ip_interno: 'IP interna',
                    ip_externo: 'IP externa',
                    ultima_atualizacao: 'Última actualización',
                    latencia: 'Latencia media',
                    disco: 'Disco Libre',
                    cpu: 'UPC',
                    periodo: 'Período',
                    minutos: 'Minutos',
                    hora: 'Hora',
                    personalizado: 'Costumbre',
                    cancelar: 'Cancelar'
                }
            },
            temperatura: {
                title: 'Temperatura',
                little_cards: {
                    temperatura: 'Temperatura',
                    umidade: 'Humedad'
                }
            },
            localizacao: {
                title: 'Ubicación',
                ultima: 'Última Ubicación',
                nenhuma_localizacao: 'No se encontró ninguna ubicación.',
            },
            log_panel: {
                codigo_erro: 'Código de error:',
                vns_equipamento: 'VNS/Equipo',
                tipo: 'Tipo',
                data_hora: 'Fecha/Hora',
                acao: 'Acción',
                ver_log: 'Ver registro',
                alerta_vns: 'Alerta VNS'
            },
            jira: {
                title: 'Jira',
                tabela_titulo: {
                    tipo: 'tipo',
                    status: 'estado',
                    data_atualizacao: 'fecha_de_actualización'
                }
            }
        }
    },
    detalhe:{
        table: {
            consumo_total: 'Consumo total',
            empresas: 'Empresas',
            unidades: 'Unidades',
            tipo: 'Tipo',
            equipamento: 'Equipo',
            com_alertas: 'Con Alertas',
            empresa: 'Empresa',
            unidade: 'Unidad',
            apelido: 'Apellido',
            ip_interno: 'IP Interna',
            ip_externo: 'IP Externa',
            latencia: 'Latencia',
            impressora: 'Impresora',
            recebidos: 'Bytes Recibidos',
            enviados: 'Bytes Enviados',
            disco_livre: 'Disco Libre',
            vns_detalhados: 'VNS\'s Detallados',
            filtro_indisponivel: 'Filtro no disponible'
        }
    },
    jira: {
        tipos_problema: {
            ip: 'Problema de Comunicacion',
            temperatura: 'Problema de Temperatura'
        },
        table: {
            empty: 'No se encontró jira'
        }
    }
}